// src/components/AddPaymentForm.js
import React, { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

const AddPaymentForm = ({
  isUpdating = false,
  paymentToUpdate = null,
  onSuccess,
  onCancel,
  newPayment,
  setNewPayment,
  setUser,
  t,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      // (Your mock save – unchanged)
      const mockPaymentMethod = {
        id: `mock_${Date.now()}`,
        type: "visa",
        last4: "4242",
        isDefault: newPayment.isDefault || false,
      };

      const currentUser = auth.currentUser;
      if (!currentUser) {
        console.error("❌ No user logged in");
        setSaving(false);
        return;
      }

      const userRef = doc(db, "users", currentUser.uid);
      const userSnap = await getDoc(userRef);
      let existing = userSnap.exists() ? userSnap.data().paymentMethods || {} : {};

      if (isUpdating && paymentToUpdate?.id && existing[paymentToUpdate.id]) {
        delete existing[paymentToUpdate.id];
      }

      if (Object.keys(existing).length === 0) {
        mockPaymentMethod.isDefault = true;
      }

      const updatedPayments = {
        ...existing,
        [mockPaymentMethod.id]: mockPaymentMethod,
      };

      await setDoc(userRef, { paymentMethods: updatedPayments }, { merge: true });

      const updatedList = Object.entries(updatedPayments).map(([id, data]) => ({
        id,
        ...data,
      }));

      setUser((prev) => ({ ...prev, paymentMethods: updatedList }));
      setNewPayment({ type: "", last4: "", isDefault: false });
      onSuccess();
    } catch (err) {
      console.error("❌ Saving payment failed:", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="account-payment-form">
      <CardElement
        className="account-card-element"
        options={{ hidePostalCode: true }}
      />

      {/* compact, modal-friendly footer */}
      <div className="modal-actions" style={{ justifyContent: "space-between" }}>
        <label className="checkbox-row">
          <input
            type="checkbox"
            checked={!!newPayment.isDefault}
            onChange={() =>
              setNewPayment((prev) => ({ ...prev, isDefault: !prev.isDefault }))
            }
          />
          {t("account.set_as_default")}
        </label>

        <div style={{ display: "flex", gap: 12 }}>
          <button type="submit" className="primary-btn" disabled={saving}>
            {saving
              ? t("common.saving") || "Saving..."
              : isUpdating
              ? t("account.update")
              : t("account.save")}
          </button>
          <button type="button" className="secondary-btn" onClick={onCancel}>
            {t("account.cancel")}
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddPaymentForm;